// Sincronizza il testo tra le textarea di Customily quando cambia il font
// Luca Siviero

(function() {
    const SELECTOR = 'textarea[name^="properties[Testo personalizzato"]';
    const DEFAULT_TEXT = "Il tuo testo\npersonalizzato";
    let currentTextarea = null;
    let defaultApplied = false;

    function getAllTextareas() {
        return [...document.querySelectorAll(SELECTOR)];
    }

    function getVisibleTextarea() {
        return getAllTextareas().find(el => el.offsetParent !== null);
    }

    function propagateToAll(value) {
        getAllTextareas().forEach(el => {
            if (el.value !== value) {
                el.value = value;
                el.dispatchEvent(new Event('input', { bubbles: true }));
                el.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    }

    function applyDefault() {
        if (defaultApplied) return;
        const all = getAllTextareas();
        if (all.length === 0) return;
        propagateToAll(DEFAULT_TEXT);
        defaultApplied = true;
    }

    const observer = new MutationObserver(() => {
        // Applica il testo di default al primo render
        applyDefault();

        const visible = getVisibleTextarea();
        if (!visible) return;
        if (visible === currentTextarea) return;

        // Textarea cambiata — propaga il valore della precedente a tutte
        if (currentTextarea) {
            propagateToAll(currentTextarea.value);
        }

        currentTextarea = visible;
    });

    observer.observe(document.body, { attributes: true, childList: true, subtree: true });
})();